import React, { Component } from 'react';
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.bubble.css'; // ES6
import _ from 'lodash'

import noImage from '../../images/common/broken-image.png'


export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    addDefaultSrc(ev) {
        ev.target.src = noImage
    }

    render() {
        let checkTextareaValue = this.props.text && this.props.text.length === 0 || this.props.text == '<p><br></p>' || this.props.text == ''

        return (
            <div className="commanLabel">
                <label>{this.props.name}</label>
                <div className="commanLabelText" style={this.props.style}>
                    {this.props.htmlView && this.props.text ?
                        <div style={{ margin: "-7px 0 0 -5px" }}>
                            <ReactQuill
                                className={`readOnlyQuill ${this.props.className ? this.props.className : "bg-light-blue "}`}
                                readOnly={true}
                                value={checkTextareaValue ? `No ${_.lowerCase(this.props.name)} added` : this.props.text}
                                theme="bubble"

                            />
                        </div>
                        :
                        this.props.text}
                    {this.props.image && <img onError={this.addDefaultSrc} src={this.props.image} className="fitImage" alt='' />}
                </div>
            </div>
        );
    }
}
